import 'modules/vesting/button-import-data'

import Breadcrumb from 'component/breadcrumb/breadcrumb'
import { BREADCRUMBS } from 'constants/breadcrumb'
import { VestingTypeEnum } from 'constants/vesting'
import { VestingProvider } from 'context/vesting-context-provider'
import Content from 'modules/vesting/content'
import Header from 'modules/vesting/header'

const VestingHMC = () => {
  return (
    <VestingProvider type={VestingTypeEnum.VESTING_HMC}>
      <div className="main-section user">
        <Breadcrumb additionalItems={[BREADCRUMBS.VESTING]} />
        <Header />
        <Content />
      </div>
    </VestingProvider>
  )
}

export default VestingHMC
